var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as locales from '@vuedir/constants/locales';
const defaultLocale = locales.LOCALE_DEFAULT;
export let i18n;
export let locale;
export function setLocale() {
    return __awaiter(this, void 0, void 0, function* () {
        const { createI18n } = yield import(/* webpackChunkName: 'vue-i18n' */ 'vue-i18n');
        // TODO: get local from html attribute
        const languageElement = document.querySelector('[data-locale-lang]');
        locale = languageElement ? languageElement.getAttribute('data-locale-lang') : defaultLocale;
        let messages = {
            // default locale always needs to be set for fallback
            // [defaultLocale]: en_US
            [defaultLocale]: yield import('@scoopsLanguagesDir/' + defaultLocale + '.json')
        };
        if (locale !== defaultLocale) {
            messages[locale] = yield import('@scoopsLanguagesDir/' + locale + '.json');
        }
        i18n = createI18n({
            locale: locale,
            fallbackLocale: defaultLocale,
            formatFallbackMessages: true,
            messages: messages
        });
    });
}
